import { useState } from 'react';
import styled from 'styled-components';
import { Button } from '../../atoms';
import { FormField } from '../../molecules';

const Form = styled.form`
  width: 100%;
  max-width: 400px;
  padding: 24px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h2`
  margin: 0 0 24px;
  font-size: 24px;
  color: #333;
  text-align: center;
`;

const LoginForm = ({ onSubmit, disabled = false }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!email) newErrors.email = '이메일을 입력해주세요';
    if (!password) newErrors.password = '비밀번호를 입력해주세요';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onSubmit({ email, password });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Title>로그인</Title>
      <FormField
        label="이메일"
        type="email"
        placeholder="이메일을 입력하세요"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        error={errors.email}
        disabled={disabled}
      />
      <FormField
        label="비밀번호"
        type="password"
        placeholder="비밀번호를 입력하세요"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        error={errors.password}
        disabled={disabled}
      />
      <Button type="submit" style={{ width: '100%' }} disabled={disabled}>
        {disabled ? '로그인 중...' : '로그인'}
      </Button>
    </Form>
  );
};

export default LoginForm;
